import styled from 'styled-components';


export const HeaderWrapper = styled.header`
    display: flex;
    align-items: center;
    background-color: white;
    justify-content: space-between;
    width: 21.8125rem; // 349px / 16
    height: 8.375rem; // 134px / 16
    position: relative;
`;

export const HeaderImage = styled.img`
    width: 21.8125rem; // 349px / 16
    height: 6.25rem; // 100px / 16
    object-fit: cover;
    border-radius: 0.75rem; // 12px / 16


    @media (min-width: 576px) and (max-width: 1200px) {
        width: 22rem;
    }
`;

export const HeaderIcon = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
